import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LimpiarService {
  public limpiarForm: BehaviorSubject<any> = new BehaviorSubject<any>(null)
}
